import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MailingListItem } from '@/models'

export type { MailingListItem }

export interface GetMailingListRequest {
  buildingId: number | undefined
}

export const getMailingListQueryKey = (data: GetMailingListRequest) => ['useGetMailingList', data]

export const getMailingList = async (
  data: GetMailingListRequest,
  signal?: AbortSignal,
): Promise<MailingListItem[]> => {
  const response = await authAPI.get<MailingListItem[]>(
    `/mailinglist/building/${data.buildingId}`,
    { signal },
  )

  return response.data
}

export const useGetMailingList = (data: GetMailingListRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: ({ signal }) => getMailingList(data, signal),
    queryKey: getMailingListQueryKey(data),
  })
}
